module.exports = __webpack_public_path__ + "media/application/images/svgs/framer-423bd088a8bf09207ca48ac0c80688ee.svg";